import Auth from '@/pages/Auth';

export default function AuthPage() {
  return <Auth />;
}
